import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type BaseConfiguratorLayoutClasses =
  | 'actionButtonsContainer'
  | 'layoutContainer'
  | 'sliderContainer'
  | 'controlsContainer'
  | 'footerContainer'
  | 'variantSliderContainer';

const baseConfiguratorLayoutStyles = makeStyles<ISpcTheme, BaseConfiguratorLayoutClasses>(
  theme => ({
    variantSliderContainer: {
      position: 'sticky',
      top: 100,
      marginTop: theme.spacing(8),
      [theme.breakpoints.down('sm')]: {
        marginBottom: 0,
        marginTop: theme.spacing(5),
      },
    },
    layoutContainer: {
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
      },
    },
    sliderContainer: {
      borderRight: `1px solid ${theme.palette.text.disabled}`,
      [theme.breakpoints.down('sm')]: {
        borderRight: 'none',
      },
      [theme.breakpoints.up('md')]: theme.spc.rightHandPanelFixedWidthSize
        ? {
            flexBasis: '100%',
            maxWidth: `calc(100% - ${theme.spc.rightHandPanelFixedWidthSize})`,
          }
        : {},
    },
    controlsContainer: {
      paddingLeft: theme.spacing(7),
      paddingTop: theme.spacing(5),
    },
    footerContainer: {
      position: 'sticky',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
    },
    actionButtonsContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      margin: '20px 0 0 0',
    },
  }),
  { name: 'Common_BaseConfiguratorLayout' },
);

export default baseConfiguratorLayoutStyles;
